   // lozad lazy-loading as directive
   var lozadDirective = {
    bind(el, binding) {
        el.setAttribute('data-background-image', binding.value) ;
        
        let vueObserver = lozad(el);
        vueObserver.observe();
    }
}
Vue.directive('lozad', lozadDirective)

var quickBuyApp = new Vue({

    name: "QuickBuyApp",
    delimiters: ['${', '}'],
    el: '#quick-buy-app',


    data: {
        collection_products: [],
        related_products: [],
        filters: [],
        selected_item: {
            product_id: null,
            product_title: null,
            variant_id: null,
            quantity: 1
        },
        scent_family: ''
    },


    methods: {
        getCollectionProducts(filters) {
            // Get collection handle from the section settings
            var collectionHandle = this.$el.getAttribute('data-collection');
            console.log('Collection handle:', collectionHandle);
            
            if (!collectionHandle) {
                console.error('No collection handle found');
                return;
            }
            
            console.log('Fetching collection products from:', '/collections/' + collectionHandle + '?view=json');
            
            fetch('/collections/' + collectionHandle + '?view=json')
                .then(response => response.json())
                .then(data => {
                    console.log('Collection data received:', data);
                    this.collection_products = data.products;
                    this.related_products = data.products;
                })
                .catch(error => {
                    console.error('Error fetching collection products:', error);
                });
        },
        filteredProducts() {
            return this.related_products.filter(function(product) {
                return product.available;
            })
        },
        clearFilters() {
            var products = $(".collection-vue__container__products"),
                filters = $(".collection-vue__container__filter"),
                buttons = $(".filter");

            if($('.js-filter-toggle__toggle').attr('aria-expanded') == "false") {
                $('.js-filter-toggle__toggle').attr('aria-expanded', 'true');
                $('.js-filter-toggle__toggle').html('hide filters');
            } else {
                $('.js-filter-toggle__toggle').attr('aria-expanded', 'false');
                $('.js-filter-toggle__toggle').html('show filters');
            }
            
            products.toggleClass('filters-active');
            filters.toggleClass('expanded');

            buttons.attr('aria-pressed', 'false');
            buttons.removeClass('is-active');
            this.filters = [];
        },
        showFilters() {
            var products = $(".collection-vue__container__products"),
                filters = $(".collection-vue__container__filter");

            if($('.js-filter-toggle__toggle').attr('aria-expanded') == "false") {
                $('.js-filter-toggle__toggle').attr('aria-expanded', 'true');
                $('.js-filter-toggle__toggle').html('hide filters');
            } else {
                $('.js-filter-toggle__toggle').attr('aria-expanded', 'false');
                $('.js-filter-toggle__toggle').html('show filters');
            }
            
            products.toggleClass('filters-active');
            filters.toggleClass('expanded');
        },
        filterTag(tag, event) {
            var button = $(event.target),
                pressed = button.attr('aria-pressed');

            if(pressed == "true") {
                this.filters.splice(this.filters.indexOf(tag), 1);
                button.attr('aria-pressed', 'false');
                button.removeClass('is-active');
                // console.log('was active, now disabled');
            } else {
                this.filters.push(tag);
                button.attr('aria-pressed', 'true');
                button.addClass('is-active');
                // console.log('was disabled, now active');
            }
        },
        selectItem(item, event) {
            $(".collection-vue__container__products__product").removeClass("is-active");

            $(event.target)
                .closest(".collection-vue__container__products__product")
                .addClass("is-active");

            var option = $(event.target)
                .closest(".collection-vue__container__products__product")
                .find(".size-selector[aria-pressed='true']");

            if(option.length == 0) {
                // set aria-pressed on first button element
                $(event.target)
                    .closest(".collection-vue__container__products__product")
                    .find(".size-selector[data-available='true']").first().attr("aria-pressed", true);

                this.selected_item = {
                    product_id: item.id,
                    product_title: item.title,
                    variant_id: item.first_variant,
                    variant_available: item.first_variant_available,
                    max_available: item.first_variant_max,
                    quantity: 1
                };
            } else {
                this.selected_item = {
                    product_id: item.id,
                    product_title: item.title,
                    variant_id: option.attr("data-id"),
                    variant_available: option.attr("data-available"),
                    max_available: option.attr("data-qty"),
                    quantity: 1
                };
            }

        },
        setVariant(variant, event) {
            var button = $(event.target)
                    .closest(".collection-vue__container__products__product")
                    .find('.addToCart');

            if(variant.available == false) {
                button.prop( "disabled", true );
                button.addClass('out-of-stock');
                button.html('out of stock');
            } else {
                button.prop( "disabled", false );
                button.removeClass('out-of-stock');
                button.html('add to bag');
            }

            var pressed = $(event.target)
                    .closest(".size-options")
                    .find(".size-selector[aria-pressed='true']");
                pressed.attr("aria-pressed", "false");

            var price = $(event.target)
                    .closest(".collection-vue__container__products__product")
                    .find(".price");
                price.html(variant.price);

            var compare_to_price = $(event.target)
                    .closest(".collection-vue__container__products__product")
                    .find(".compare-to-price");
                compare_to_price.html(variant.compare_to_price);

            $(event.target).attr("aria-pressed", "true");
            $(event.target)
                    .closest(".collection-vue__container__products__product")
                    .find(".front-img").css('backgroundImage', 'url('+ variant.image + ')');

            this.selected_item.variant_id = variant.id;
            this.selected_item.variant_available = variant.available;
            this.selected_item.max_available = variant.quantity;
        },
        addItemToBag(event) {
            var quickAddBtn = $(event.target)
                    .closest(".product-cta")
                    .find('.quick-add');

            var productTitle = this.selected_item.product_title;

            // Updated add to cart with correct success
            $.ajax({
                url: '/cart/add.json',
                type: 'post',
                dataType: 'json',
                data: {
                    quantity: this.selected_item.quantity,
                    id: this.selected_item.variant_id
                },
                success: function(response) {
                    console.log('');
                    console.log('%c' + response.title + "%c was added to cart.", 'color: green','color: black',);

                    if(showVueCart == true) {
                        window.miniCart.refreshCart();
                    }
                },
                error: function(response) {
                    var errors = JSON.parse(response.responseText);
                    console.log(errors.errors);
                }
            });


            this.selected_item = {
                product_id: null,
                product_title: null,
                variant_id: null,
                quantity: 1
            };

            $(".collection-vue__container__products__product").removeClass("is-active");

            quickAddBtn.html('Added!');
            quickAddBtn.addClass('added');

            setTimeout(function() {
                quickAddBtn.html('quick add');
                quickAddBtn.removeClass('added');
            }, 2500);
        }
    },


    watch: {

    },


    computed: {
        maxQTY() {
            return this.selected_item.quantity >= this.selected_item.max_available;
        },
    },


    mounted: function () {
        console.log('Quick Buy Vue app mounted');
        this.getCollectionProducts();
    }

})